module.exports = __webpack_public_path__ + "img/event-people-rot.6f2868de.svg";